import choosePlan from '../common/adhesion/choose-plan.vue'
import chooseRecharge from '../common/adhesion/choose-recharge.vue'
import userData from '../common/adhesion/user-data.vue'
import companyData from '../common/adhesion/company-data.vue'
import vehicles from '../common/adhesion/vehicles.vue'
import payment from '../common/adhesion/payment.vue'
import summaryComp from '../common/adhesion/summary.vue'
import * as obj from '../common/adhesion/objects'
import Sales from '../../services/sales'
import C from '../common/constantes'
import successPage from '../common/adhesion/success.vue'
import errorPage from '../common/adhesion/error.vue'
import messageDialog from '../../components/message-dialog';
import * as Utils from '../../utils';
import {EventBus} from '../../event-bus'

const subs = ['', 'Queremos saber mais sobre a empresa, por gentileza, informe os dados abaixo:', 'Informe a forma de pagamento:', ''];

export default {
  props: ['type'],
  data() {
    return {
      account: undefined,
      address: obj.address(),
      contract: obj.contract(),


      vehicles: [],
      step: 0,
      subtitle: subs,
      msgError: undefined,
      loading: undefined,
      success: false,
      code: undefined,
      boletoUrl: undefined,
      showRecharge: true,
      planId: 6,
      lead: undefined,
      minValue: 200000
    }
  },

  computed: {
    payment() {
      return this.contract.paymentMethods.paymentMethod[0]
    },
    qtdAllowed() {
      return C.LIMIT_VEHICLES;
    },
    request() {
      let vm = this;
      let request = {
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        account: vm.account,
        addresses: {
          address: [
            vm.address
          ]
        },
        contract: vm.contract,
        listVehicle: {
          vehicle: vm.vehicles
        },
        value: undefined
      };
      return request;
    },
    isPJ() {
      if(this.lead)
        return this.lead.typeTaxId == 'COMPANY';

      return C.isPJ(this.planId);
    },
    isCaminhoParana(){
      return !!this.lead;
    },
    plan(){
      return this.$store.getters.getPlanById(this.planId);
    },
    planName(){
      return this.plan && this.plan.name;
    },
    newAdhesionTax(){
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    newVehicleTax(){
      return this.$store.getters.getNewVehicleTax(this.planId);
    },
    guaranteeTax(){
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    bankAccountOptions(){
      return this.$store.getters.getBankAccountOptions(this.planId);
    },
    creditCardOptions(){
      return this.$store.getters.getCreditCardOptions(this.planId);
    },
    bankBillOption(){
      return this.$store.getters.getBankBillOption(this.planId);
    },
    tedOption(){
      return this.$store.getters.getTedOption(this.planId);
    },
    docOption(){
      return this.$store.getters.getDocOption(this.planId);
    },

  },

  watch:{
    $route(){
      
      this.planId = this.$route.query.planId;
      this.account = this.isPJ ? obj.companyAccount() : obj.account();
      this.account.taxIdNumber = this.$route.query.taxIdNumber;
      this.account.taxIdNumberFormatted = this.formatTaxId(this.$route.query.taxIdNumber);
    }
  },

  created() {
    this.contract.plan.planId = this.planId;
    this.$store.commit('resetLoading');

    if (window.ga) window.ga('send', 'pageview', 'adesao/etapa-embarcador');

    sessionStorage.removeItem('lead');

    this.$store.commit('currentPlanId', this.planId);
    

    if (!this.account) {

      this.account = this.isPJ ? obj.companyAccount() : obj.account();

      if (this.lead) {
        this.address = obj.address();
        this.account.taxIdNumber = this.lead.taxpayerIdNumber;
        this.account.accountAuthentication.login = this.lead.contactEmail;
        this.address.zipCode.zipCode = this.lead.zipCode;
        let leadTels = this.lead.phone ? this.lead.phone.split(';') : [];

        if (leadTels.length && leadTels[0].length > 2) {
          leadTels[0] = leadTels[0].replace(/[^0-9]/g, '').replace(/^0/, '');
          this.account.telephones.telephone[1].ddd = leadTels[0].substring(0, 2);
          this.account.telephones.telephone[1].numberPhone = leadTels[0].substring(2);
        }

        if (this.isPJ) {
          this.account.company.companyName = this.lead.companyName;
          this.account.company.companyTradeName = this.lead.companyName;
          this.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
        } else {
          this.account.person.fullName = this.lead.companyName;
          this.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
        }
      }
    }


    this.getPlanInfo();
    this.$on('goToStep', (value) => {
      this.step = value;
    });

    EventBus.$on('cleanErrors', () => {
      this.msgError = undefined;
    });

  },

  mounted() {
    let vm = this;

  },

  // beforeDestroy(){
  //   
  //   sessionStorage.removeItem("lead");
  // },

  methods: {
    nextStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          let p;
          if(this.planId == 31 || this.planId == 32 || this.planId == 5){
            p = this.$refs.chooseRecharge.validateAll();
          } else {
            p = this.$refs.choosePlan.validateAll();
          }
          p.then(r => {
            this.step += 1;
          }).catch(err => {
            
            if(this.planId == 2 || this.planId == 3)
              this.msgError = 'Infome um CPF ou CNPJ válido para continuar';
            else
              this.msgError = 'Por favor verifique o valor de recarga';
          });
          break;
        case 1:
          this.$refs.userData.validateAll().then(r => {
            this.step += 1;
          }).catch(err => {
            this.msgError = 'Por favor verifique os campos com erro';
          });
          break;
        case 2:
          this.$refs.payment.validateAll().then(r => {
            this.step += 1;
          }).catch(err => {
            this.msgError = 'Por favor verifique os campos com erro';
          });
          break;
        case 3:

          break;
      }

      if (window.ga && !this.msgError) window.ga('send', 'pageview', 'adesao/etapa' + (this.step+1));

    },
    backStep() {
      if(this.step == 0){
        this.cancelar();
        return;
      }

      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      this.step -= 1;
    },
    cancelar() {
      messageDialog.show({
        title: 'Cancelar Adesão',
        message: 'Deseja cancelar a adesão?',
        type: 'OK-CANCEL-ADHESION'
      }).then(res => {
        if (res == 'OK') {
          sessionStorage.removeItem("lead");
          if(this.planId && this.getKindPlan(this.planId) == 'RNTRC')
            this.$router.push({name: 'home'});
          else if(this.isPJ)
            this.$router.push({name: 'services-b2b'});
          else
            this.$router.push({name: 'services-b2c'});
        }
      });

    },
    getPlanInfo() {

    },
    doRequest() {
      this.$refs.summary.validateAll().then(r => {
        let promise = Sales.adhesion(this.request).then(r => {
          this.code = r.status.code;
          this.boletoUrl = r.boletoUrl;
          $('body').stop().animate({
            scrollTop: 0
          }, '500', 'swing');
        }).catch(err => {
          this.msgError = err.data.status.message;
          this.code = err.data.status.code;
          $('body').stop().animate({
            scrollTop: 0
          }, '500', 'swing');
        });

        this.$store.dispatch('loading', promise);

      });
    },
    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
    nextParana(plan){
      if(plan == 'man'){
        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 37 : 35;
      } else {
        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 38 : 36;
      }
      this.$store.commit('currentPlanId', this.contract.plan.planId);

      this.nextStep();

    }

  },
  components: {
    choosePlan,
    chooseRecharge,
    userData,
    vehicles,
    payment,
    summaryComp,
    successPage,
    errorPage,
    companyData
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/adhesion-shipper.js